var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJourney1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 99,
    viewBox: "0 0 128 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.973 102.185C157.611 105.272 152.279 107.331 146.626 108.886C115.461 117.458 75.4445 120.833 46.6909 104.188C34.5575 97.1647 27.8416 85.205 29.1648 72.1355C30.4559 59.3978 38.388 53.2475 51.7625 51.2291C81.7537 46.7026 114.306 45.4733 144.475 49.1975C151.002 50.003 157.793 51.2712 162.843 55.1099C167.433 58.5998 170.022 63.827 171.495 69.0962C173.568 76.4869 173.685 84.4823 170.672 91.6004C168.76 96.1116 165.725 99.5287 161.973 102.185Z",
    fill: "#C1DFEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.669 7.82133C18.534 8.53067 16.2502 11.3901 15.4373 14.453C11.8557 27.9372 31.089 46.7709 43.4777 47.9297C58.5421 49.339 66.1604 29.1676 69.2371 14.9061C70.4346 9.35784 68.2018 2.64847 62.8213 0.612109C58.0003 -1.21279 52.4813 1.2854 48.8523 4.90184C47.1244 6.62218 45.6171 8.63092 43.4846 9.83401C40.9747 11.2514 37.8725 11.3589 35.0492 10.7311C34.054 10.5096 33.0935 10.1945 32.1493 9.84818C28.7428 8.59846 25.5513 6.94286 21.669 7.82133Z",
    fill: "#F18273"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7302 43.8987C36.3283 46.1551 39.9801 47.6306 43.1763 47.9295C58.2407 49.3389 65.859 29.1674 68.9357 14.9059C69.7457 11.153 68.9862 6.86875 66.7446 3.85889C66.726 4.00129 66.7072 4.1459 66.6884 4.29274C63.2833 30.8393 39.1658 41.5065 32.7302 43.8987Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJourney1);
export default __webpack_public_path__ + "static/media/journey1.0dae4335658fb98da2944d233ecfb62f.svg";
export { ForwardRef as ReactComponent };